import request from '@/utils/request'

// 查询用户优惠券分页
export function pageUserCoupon(query) {
  return request({
    url: '/userCoupon/userCoupon/page',
    method: 'get',
    params: query
  })
}
